"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Logger_1 = __importDefault(require("./Logger"));
class RenderStreamingCallback {
    _onSignalingConnectionCallback;
    _onSignalingDisconnectCallback;
    _onWebRtcConnectionCallback;
    _onWebRtcDisconnectCallback;
    _onWebRtcDatachannelOpen;
    _onWebRtcDatachannelClosedCallback;
    _onMatchmakerSignalingConnectionDataReceivedCallback;
    _onMatchmakerConnectionCallback;
    _onMatchmakerDisconnectCallback;
    _onRenderStreamingReady = () => { };
    constructor() {
        this.clearEvents();
    }
    clearEvents() {
        this._onSignalingConnectionCallback = (e) => { Logger_1.default.info("Signaling Connected."); };
        this._onSignalingDisconnectCallback = () => { Logger_1.default.info("Signaling Disconnected."); };
        this._onWebRtcConnectionCallback = (e) => { Logger_1.default.info("WebRTC Connected."); };
        this._onWebRtcDisconnectCallback = (e) => { Logger_1.default.info("Signaling Disconnected."); };
        this._onWebRtcDatachannelOpen = (e) => { Logger_1.default.info("WebRTC Data channel opened"); };
        this._onWebRtcDatachannelClosedCallback = () => { Logger_1.default.info("Data channel closed."); };
        this._onMatchmakerSignalingConnectionDataReceivedCallback = (e) => { Logger_1.default.info(`Signaling Connection Data Received: ${e.id}`); };
        this._onMatchmakerConnectionCallback = () => { };
        this._onMatchmakerDisconnectCallback = (e) => { };
    }
    onSignalingConnection(callback) {
        this._onSignalingConnectionCallback = callback;
    }
    onSignalingDisconnect(callback) {
        console.log("Override onSignalingDisconnect");
        console.log(callback);
        this._onSignalingDisconnectCallback = callback;
    }
    onWebRtcConnection(callback) {
        this._onWebRtcConnectionCallback = callback;
    }
    onWebRtcDisconnect(callback) {
        this._onWebRtcDisconnectCallback = callback;
    }
    onWebRtcDatachannelOpen(callback) {
        this._onWebRtcDatachannelOpen = callback;
    }
    onWebRtcDatachannelClosed(callback) {
        this._onWebRtcDatachannelClosedCallback = callback;
    }
    onMatchmakerSignalingDataReceived(callback) {
        this._onMatchmakerSignalingConnectionDataReceivedCallback = callback;
    }
    onMatchmakerConnection(callback) {
        this._onMatchmakerConnectionCallback = callback;
    }
    onMatchmakerDisconnect(callback) {
        this._onMatchmakerDisconnectCallback = callback;
    }
    onRenderStreamingReady(callback) {
        this._onRenderStreamingReady = callback;
    }
}
exports.default = RenderStreamingCallback;
